/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { customJourneyTypeEntryPoint } from '@jira/spa-apps__servicedesk-custom-journey/src/customJourneyTypeEntryPoint.entrypoint.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { customJourneyTypeRoute } from '@jira/router-routes__journeys-routes/src/customJourneyTypeRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';

const customJourneyTypePageEntryPoint = createPageEntryPoint({
	main: customJourneyTypeEntryPoint,
});

export const customJourneyTypeRouteEntry: Route = createEntry(customJourneyTypeRoute, () => ({
	group: 'servicedesk',
	ufoName: 'jsm.journey-type',
	// eslint-disable-next-line no-restricted-syntax
	component: () => null,

	navigation: {
		menuId: MenuIdProjects,
	},

	layout: serviceProjectLayout,

	resources: [
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		getConsolidationStateResource(),
	],

	entryPoint: () => customJourneyTypePageEntryPoint,

	meta: {
		reporting: {
			id: 'journey-type',
			packageName: toPackageName(APP_NAMES.JOURNEYS),
			teamName: 'JSM Grape Soju',
		},
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
